import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import {
  AFFILIATE_PROGRAM_ADMIN_FEES_PERMISSIONS,
  AFFILIATE_PROGRAM_DELETE_ADMIN_FEES_API_URL,
  AFFILIATE_PROGRAM_DELETE_ADMIN_FEES_MUTATION,
  AFFILIATE_PROGRAM_SHOW_ADMIN_FEES_QUERY_KEY,
} from '../constants';

export default function useDeleteHistoryOfAdminFeesMutation(): IContextMutationResult<
  void,
  Error,
  number
> {
  const { fetchDelete } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, number>({
    mutationKey: [AFFILIATE_PROGRAM_DELETE_ADMIN_FEES_MUTATION],
    mutationFn: (id) => fetchDelete<void>(
      AFFILIATE_PROGRAM_DELETE_ADMIN_FEES_API_URL,
      {
        permission: AFFILIATE_PROGRAM_ADMIN_FEES_PERMISSIONS.DELETE,
        urlParams: {
          id,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [AFFILIATE_PROGRAM_SHOW_ADMIN_FEES_QUERY_KEY] });
      displayPresetToast('removed');
    },
  });
}
